import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { FlexDiv, P } from 'components/generic/HomePageComponents'

const EasyEffectiveAffordable = ({
  data: { imageSrc, bodyCopy, innerDivColor, outerDivColor },
}) => (
  <>
    <FlexDiv justifyContent='center'>
      <GenericLazyLoadImage src={imageSrc} ml='10px' mr='10px' mt='50px' maxWidth='950px' />
    </FlexDiv>
    <FlexDiv
      justifyContent='center'
      backgroundColor={outerDivColor}
      width='100%'
      padding='80px 0 70px 0'
    >
      <FlexDiv
        backgroundColor={innerDivColor}
        padding='50px 50px 50px 50px'
        width='80%'
        maxWidth={['100%', '90%', '980px']}
        justifyContent='center'
      >
        <P
          fontSize='32px'
          lineHeight='38px'
          textAlign='center'
          maxWidth='70%'
          color='#fff'
          fontWeight='700'
        >
          {bodyCopy}
        </P>
      </FlexDiv>
    </FlexDiv>
  </>
)
export default EasyEffectiveAffordable
